module.exports = __webpack_public_path__ + "static/media/TN-Men-Outer.859c54fb.svg";